module.exports = __webpack_public_path__ + "static/media/iot-application-05.4459afa2.jpg";